import { sortBy } from 'lodash-es';

import { CurrencyPipe } from '@angular/common';
import {
  IBasicOptionSummary,
  IBasicOptionValue,
} from '@nibtravel/shared/util/models';
import { IRadio } from '@nibtravel/shared/ui/forms/radio-group';
import { OptionType } from '@nibtravel/shared/util/models';

export class OptionHelper {
  public static getBasicOptionValues(
    basicOptionSummary: IBasicOptionSummary
  ): IBasicOptionValue[] {
    let optionValues = [
      ...[basicOptionSummary.optOutValue],
      ...basicOptionSummary.optInValues,
    ]
      .filter((optionValue) => optionValue !== undefined)
      .map((optionValue) => optionValue as IBasicOptionValue);
    optionValues = sortBy(optionValues, 'totalValue');
    return optionValues;
  }

  public static buildRadio(
    optionType: OptionType,
    index: number,
    labelText: string,
    radioValue: any,
    radioChecked: boolean,
    e2eId: string
  ): IRadio {
    return {
      hostId: `${optionType}-host-${index}`,
      inputId: `${optionType}-input-${index}`,
      name: `${optionType.toLowerCase()}-${radioValue}`,
      label: labelText,
      labelId: `${optionType}-label-${index}`,
      value: radioValue,
      checked: radioChecked,
      e2eId: e2eId,
    };
  }

  public static getCurrencyAmount(
    amount: number | undefined,
    currencyCode: string,
    currencyPipe: CurrencyPipe
  ): string {
    if (amount === undefined || isNaN(amount)) {
      return '';
    }
    return currencyPipe.transform(amount, currencyCode) ?? '';
  }
}
